/**
 * Yvine Design — header behaviours (one init, the former inline blocks in order).
 * Cached asset, initialised once per [data-art="header"] element by art-core.js
 * (first paint, every in-place page swap, theme-editor reloads).
 */
Art.section('header', function (root) {
  // ---- Hoist the fixed app-nav + mobile drawer to <body> ----
(function () {
      ['.art-header__appnav', '.art-header__mobile', '.art-header__crumbs'].forEach(function (sel) {
    // Drop any stale copy left directly in <body> from a previous render
    // (e.g. a theme-editor section reload) before moving the current one.
    document.querySelectorAll('body > ' + sel).forEach(function (old) { old.remove(); });
    var el = root.querySelector(sel);
    if (el) document.body.appendChild(el);
  });
})();

  // ---- Breadcrumb strip (phones): mirror the page's trail above the app bar ----
(function () {
  var strip = document.querySelector('body > .art-header__crumbs');
  if (!strip) return;
  function mirror() {
    var src = document.querySelector('#MainContent .art-crumbs');
    strip.innerHTML = src ? src.innerHTML : '';
    strip.hidden = !src;
    document.documentElement.classList.toggle('art-has-crumbs', !!src);
  }
  mirror();
  document.addEventListener('art:page:swap', mirror);
  document.addEventListener('shopify:section:load', mirror);
})();

  // ---- Cart badge, sparkle burst, request cancelling on navigation ----
(function () {
  var header = root;
  var cartLinks = document.querySelectorAll('.art-header__cart');
  if (!cartLinks.length) return;

  // Shared registry of in-flight header requests so a navigation click can
  // cancel them and free up the browser's limited connections immediately.
  var pending = (window.__ahPending = window.__ahPending || new Set());
  var navigating = false;

  function setCount(count) {
    cartLinks.forEach(function (cartLink) {
      var badge = cartLink.querySelector('.art-header__cart-count');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'art-header__cart-count';
          cartLink.appendChild(badge);
        }
        badge.textContent = count;
      } else if (badge) {
        badge.remove();
      }
      // Badge breathes only while the cart holds items.
      cartLink.classList.toggle('art-header__cart--filled', count > 0);
    });
  }

  var refreshing = false;
  function refreshCart() {
    if (refreshing || navigating) return;
    refreshing = true;
    var ac = new AbortController();
    pending.add(ac);
    fetch(root.getAttribute('data-cart-url') + '.js', { headers: { 'Accept': 'application/json' }, signal: ac.signal })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        setCount(cart.item_count);
        if (window.__ahSpiritsUpdate) window.__ahSpiritsUpdate(cart.item_count, cart.total_price);
      })
      .catch(function () {})
      .then(function () { refreshing = false; pending.delete(ac); });
  }

  // Sparkle burst around the cart icon when an item is added
  function sparkle() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    cartLinks.forEach(function (cartLink) {
      // Only animate the cart icon the visitor can actually see.
      if (!cartLink.offsetParent) return;
      cartLink.classList.remove('art-header__cart--pop');
      void cartLink.offsetWidth; // restart animation
      cartLink.classList.add('art-header__cart--pop');

      var burst = document.createElement('span');
      burst.className = 'art-header__sparkles';
      var n = 8;
      for (var i = 0; i < n; i++) {
        var s = document.createElement('i');
        var angle = (360 / n) * i + (Math.random() * 24 - 12);
        var dist = 16 + Math.random() * 12;
        s.style.setProperty('--dx', (Math.cos(angle * Math.PI / 180) * dist).toFixed(1) + 'px');
        s.style.setProperty('--dy', (Math.sin(angle * Math.PI / 180) * dist).toFixed(1) + 'px');
        s.style.setProperty('--d', (Math.random() * 80).toFixed(0) + 'ms');
        burst.appendChild(s);
      }
      cartLink.appendChild(burst);
      setTimeout(function () { burst.remove(); }, 900);
    });
  }

  var cartRoute = /\/cart\/(add|change|update|clear)(\.js|\b)/i;
  var addRoute = /\/cart\/add(\.js|\b)/i;

  // Intercept fetch-based cart mutations (Horizon + most modern themes use fetch)
  var nativeFetch = window.fetch;
  if (nativeFetch) {
    window.fetch = function () {
      var first = arguments[0];
      var url = (first && first.url) ? first.url : first;
      return nativeFetch.apply(this, arguments).then(function (response) {
        try {
          if (typeof url === 'string' && cartRoute.test(url)) {
            refreshCart();
            if (response.ok && addRoute.test(url)) sparkle();
          }
        } catch (e) {}
        return response;
      });
    };
  }

  // Fallback for XHR-based cart mutations
  var nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (typeof url === 'string' && cartRoute.test(url)) {
      var isAdd = addRoute.test(url);
      this.addEventListener('load', function () {
        refreshCart();
        if (isAdd && this.status >= 200 && this.status < 300) sparkle();
      });
    }
    return nativeOpen.apply(this, arguments);
  };

  // Standard theme cart events as additional triggers
  ['cart:updated', 'cart:refresh', 'cart:change', 'cart:build'].forEach(function (evt) {
    document.addEventListener(evt, refreshCart);
  });

  // Sync when returning to the tab (e.g. after another tab changed the cart)
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) refreshCart();
  });

  // Snappy header navigation: the moment a header link is clicked, abort any
  // in-flight header requests (cart poll, predictive search) so they stop
  // competing with the new page's document request. Capture phase + pointerdown
  // fire before the browser starts the navigation, so the first click "takes".
  function cancelPending() {
    navigating = true;
    pending.forEach(function (ac) { try { ac.abort(); } catch (e) {} });
    pending.clear();
  }
  function isPlainNav(e) {
    if (e.defaultPrevented || e.button != null && e.button !== 0) return false;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return false;
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a) return false;
    if (a.target && a.target !== '_self') return false;
    // Ignore pure in-page anchors (no real navigation).
    if (a.getAttribute('href').charAt(0) === '#') return false;
    return true;
  }
  header.addEventListener('pointerdown', function (e) {
    if (isPlainNav(e)) cancelPending();
  }, true);
  header.addEventListener('click', function (e) {
    if (isPlainNav(e)) cancelPending();
  }, true);
  // If a navigation is starting for any other reason, stop polling too.
  window.addEventListener('pagehide', cancelPending);
})();

  // ---- Roaming / orbiting spirits ----
(function () {
  
  function createSpirits(container, stopSelector) {
  var layer = document.createElement('span');
  layer.className = 'art-header__spirit-layer';
  container.appendChild(layer);

  var spirits = [];
  var mode = '';           // 'roam' | 'orbit'
  var raf = null;
  var lastTs = null;

  // getClientRects (not offsetParent) so position:fixed clusters like the
  // mobile app-nav still count as visible; display:none yields no rects.
  function visible(el) { return !!(el && el.getClientRects().length); }
  function iconTargets() {
    // The roaming spirit only visits the given stops for this cluster.
    return Array.prototype.slice
      .call(container.querySelectorAll(stopSelector))
      .filter(visible);
  }
  function cartTarget() { return container.querySelector('.art-header__cart'); }

  function centerOf(el) {
    var lr = layer.getBoundingClientRect();
    var r = el.getBoundingClientRect();
    return { x: r.left - lr.left + r.width / 2, y: r.top - lr.top + r.height / 2 };
  }
  function place(sp, x, y) {
    sp.el.style.transform = 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px) translate(-50%,-50%)';
  }
  function makeSpirit() {
    var el = document.createElement('span');
    el.className = 'art-header__spirit';
    el.setAttribute('aria-hidden', 'true');
    layer.appendChild(el);
    return { el: el, t: Math.random() * 6, speed: 1.25 + Math.random() * 0.55, phase: 'orbit', i: 0, loops: 1 };
  }
  function setSpiritCount(n) {
    while (spirits.length < n) spirits.push(makeSpirit());
    while (spirits.length > n) spirits.pop().el.remove();
  }

  // ---- Roam: the spirit dances a figure-8 around an icon (sometimes a full
  // loop or two, sometimes only half), then glides on to another icon. It
  // mostly steps to a neighbour but now and then hops further and back.
  function pickNext(i, count) {
    if (count < 2) return i;
    var r = Math.random();
    if (r < 0.62) {
      // step to an adjacent icon (wrap around)
      var dir = Math.random() < 0.5 ? -1 : 1;
      return (i + dir + count) % count;
    }
    // hop somewhere further away
    var j = i;
    while (j === i) j = Math.floor(Math.random() * count);
    return j;
  }
  function tickRoam(dt) {
    var icons = iconTargets();
    if (!icons.length) return;
    var sp = spirits[0];
    if (!sp) return;
    sp.i = sp.i % icons.length;

    if (sp.phase === 'orbit') {
      sp.t += dt;
      var c = centerOf(icons[sp.i]);
      // Same gentle angular speed as the cart orbit, traced as a figure-8.
      var w = sp.t * sp.speed;
      var R = 14;
      var ox = Math.sin(w) * R;
      var oy = Math.sin(w * 2) * (R * 0.55); // figure-8
      place(sp, c.x + ox, c.y + oy);
      // sp.loops can be a fraction (e.g. 0.5 = half a figure-8) up to ~2.
      if (w >= Math.PI * 2 * sp.loops) {
        sp.phase = 'travel';
        sp.t = 0;
        sp.from = { x: c.x + ox, y: c.y + oy };
        sp.next = pickNext(sp.i, icons.length);
        var far = Math.abs(sp.next - sp.i);
        far = Math.min(far, icons.length - far); // wrap distance
        sp.travelDur = 0.85 + far * 0.28 + Math.random() * 0.4;
      }
    } else {
      sp.t += dt;
      var to = centerOf(icons[sp.next]);
      var k = Math.min(1, sp.t / sp.travelDur);
      var e = k < 0.5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2; // easeInOut
      var mx = (sp.from.x + to.x) / 2;
      var my = (sp.from.y + to.y) / 2 - 18; // arc up between icons
      var x = (1 - e) * (1 - e) * sp.from.x + 2 * (1 - e) * e * mx + e * e * to.x;
      var y = (1 - e) * (1 - e) * sp.from.y + 2 * (1 - e) * e * my + e * e * to.y;
      place(sp, x, y);
      if (k >= 1) {
        sp.i = sp.next;
        sp.phase = 'orbit';
        sp.t = 0;
        // Vary the dance: ~half the time a single loop, sometimes just half,
        // occasionally a double.
        var r = Math.random();
        sp.loops = r < 0.3 ? 0.5 : (r < 0.8 ? 1 : 2);
      }
    }
  }

  // ---- Orbit: N spirits circle the cart icon, evenly spaced + wobbling
  function tickOrbit(dt) {
    var cart = cartTarget();
    if (!visible(cart)) return;
    var c = centerOf(cart);
    var n = spirits.length || 1;
    for (var i = 0; i < spirits.length; i++) {
      var sp = spirits[i];
      sp.t += dt;
      var ang = sp.t * sp.speed + (i / n) * Math.PI * 2;
      var R = 14 + Math.sin(sp.t * 1.3 + i) * 3;
      place(sp, c.x + Math.cos(ang) * R, c.y + Math.sin(ang) * R * 0.82);
    }
  }

  function frame(ts) {
    if (lastTs == null) lastTs = ts;
    var dt = Math.min(0.05, (ts - lastTs) / 1000);
    lastTs = ts;
    if (visible(container)) {
      if (mode === 'orbit') tickOrbit(dt); else tickRoam(dt);
    }
    raf = requestAnimationFrame(frame);
  }
  function start() {
    if (raf == null) { lastTs = null; raf = requestAnimationFrame(frame); }
  }
  function stop() {
    if (raf != null) { cancelAnimationFrame(raf); raf = null; }
  }

  // ---- React to cart state (item count + total in minor units)
  function update(itemCount, totalMinor) {
    if (itemCount > 0) {
      var eur = (totalMinor || 0) / 100;
      var n = Math.min(5, 1 + Math.floor(eur / 20));
      if (mode !== 'orbit') {
        mode = 'orbit';
        spirits.forEach(function (sp) { sp.t = Math.random() * 6; });
      }
      setSpiritCount(n);
    } else {
      if (mode !== 'roam') {
        mode = 'roam';
        spirits.forEach(function (sp) { sp.phase = 'orbit'; sp.t = 0; sp.i = 0; sp.loops = 1; });
      }
      setSpiritCount(1);
    }
  }

  return { update: update, start: start, stop: stop };
  }

  // The desktop actions cluster (social / cart / account) and the mobile
  // bottom app-nav each get their own roaming spirit; only the cluster that
  // is currently visible animates.
  var engines = [];
  var actions = root.querySelector('.art-header__actions');
  if (actions) engines.push(createSpirits(actions, '[data-spirit-stop]'));
  // The app-nav is hoisted to <body> (see the fixed-position relocation
  // script above) so it is no longer inside `root` — query the document.
  var appnav = document.querySelector('.art-header__appnav');
  if (appnav) engines.push(createSpirits(appnav, '.art-appnav__item'));
  if (!engines.length) return;

  window.__ahSpiritsUpdate = function (itemCount, totalMinor) {
    engines.forEach(function (e) { e.update(itemCount, totalMinor); });
  };

  document.addEventListener('visibilitychange', function () {
    engines.forEach(function (e) { if (document.hidden) e.stop(); else e.start(); });
  });

  // Seed from the server-rendered cart, then animate.
  window.__ahSpiritsUpdate(parseInt(root.getAttribute('data-cart-count'), 10) || 0, parseInt(root.getAttribute('data-cart-total'), 10) || 0);
  engines.forEach(function (e) { e.start(); });
})();

  // ---- Language + social dropdowns ----
(function () {
      var dropdowns = root.querySelectorAll('[data-lang], [data-social]');
  if (!dropdowns.length) return;

  function closeAll(except) {
    dropdowns.forEach(function (d) {
      if (d !== except && d.open) d.open = false;
    });
  }

  // Opening one closes the others.
  dropdowns.forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (d.open) closeAll(d);
    });
  });

  document.addEventListener('click', function (e) {
    for (var i = 0; i < dropdowns.length; i++) {
      if (dropdowns[i].open && !dropdowns[i].contains(e.target)) dropdowns[i].open = false;
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll(null);
  });
})();

  // ---- Mobile drawer ----
(function () {
      var drawer = document.querySelector('.art-header__mobile');
  var openBtn = document.querySelector('[data-menu-toggle]');
  var closeBtns = document.querySelectorAll('[data-menu-close]'); // head X + bottom-right X
  if (!drawer || !openBtn) return;

  function setOpen(on) {
    drawer.open = on;
    openBtn.setAttribute('aria-expanded', on ? 'true' : 'false');
    document.documentElement.classList.toggle('art-menu-open', on);
  }

  openBtn.addEventListener('click', function () { setOpen(!drawer.open); });
  closeBtns.forEach(function (b) { b.addEventListener('click', function () { setOpen(false); }); });

  // Close after tapping any link, on Escape, or when tapping the backdrop.
  drawer.addEventListener('click', function (e) {
    if (e.target === drawer) { setOpen(false); return; } // (no backdrop any more; kept for the tablet/desktop details box)
    if (e.target.closest('a') || e.target.closest('.art-header__search-toggle')) setOpen(false);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.open) setOpen(false);
  });
  drawer.addEventListener('toggle', function () {
    openBtn.setAttribute('aria-expanded', drawer.open ? 'true' : 'false');
    document.documentElement.classList.toggle('art-menu-open', drawer.open);
  });
})();

  // ---- Condensing sticky header ----
(function () {
  var header = root;
  var headerGroup = document.getElementById('header-group');

  function currentScroll(evt) {
    var winY = window.pageYOffset
      || document.documentElement.scrollTop
      || document.body.scrollTop
      || 0;
    // If the scroll came from an inner scroll container, use its offset too.
    var t = evt && evt.target;
    var targetY = (t && t.scrollTop) ? t.scrollTop : 0;
    return Math.max(winY, targetY);
  }

  // Hysteresis: condense only after clearly scrolling past the tall header,
  // and expand again only near the very top. The dead-band between the two
  // thresholds stops the state from flapping on tiny scroll jitter near the
  // boundary. (The header no longer changes the group's flow height thanks to
  // reserveHeight() below, so there is no scroll-anchoring nudge to fight.)
  var CONDENSE_AT = 56; // px scrolled down -> switch to the slim header
  var EXPAND_AT = 12; //   px scrolled up   -> switch back to the tall header

  var ticking = false;
  var condensed = false;
  function update(evt) {
    ticking = false;
    var y = currentScroll(evt);
    if (!condensed && y > CONDENSE_AT) condensed = true;
    else if (condensed && y < EXPAND_AT) condensed = false;
    else return; // inside the dead-band: no class change, no reflow
    header.classList.toggle('art-header--scrolled', condensed);
  }

  // Lock the sticky group's flow height to the TALL header size so condensing
  // the bar never changes how much vertical space the header occupies -> the
  // content below can't shift, so there is no scroll jump. Pure layout work,
  // runs on load / resize only (no per-frame cost, no scroll manipulation).
  // The reserved area beneath the slim bar is transparent + click-through
  // (see art-layout.css), so content scrolls under it normally.
  function reserveHeight() {
    if (!headerGroup) return;
    // Kill transitions so offsetHeight reflects the tall layout immediately,
    // not a mid-animation value.
    header.classList.add('art-measuring');
    var wasScrolled = header.classList.contains('art-header--scrolled');
    if (wasScrolled) header.classList.remove('art-header--scrolled');
    headerGroup.style.minHeight = '';
    var tall = headerGroup.offsetHeight; // forced sync measure at tall size
    if (wasScrolled) header.classList.add('art-header--scrolled');
    headerGroup.style.minHeight = tall + 'px';

    // Publish the CONDENSED bar height, so anything that sticks below the
    // header (the gallery's collection nav) can sit right under it instead of
    // guessing a number that breaks the moment the header changes. Condensed
    // is the right one to publish: sticky only matters once you have scrolled,
    // and by then the bar has already shrunk.
    var bar = header.querySelector('.art-header__bar');
    if (bar) {
      header.classList.add('art-header--scrolled');
      var slim = bar.offsetHeight;
      if (!wasScrolled) header.classList.remove('art-header--scrolled');
      document.documentElement.style.setProperty('--art-header-bar', slim + 'px');
    }

    void headerGroup.offsetHeight; // commit the condensed state without animating
    header.classList.remove('art-measuring');
  }

  var resizeRaf = null;
  function onResize() {
    if (resizeRaf != null) return;
    if (window.Art && Art.keyboardResize && Art.keyboardResize()) return; // the keyboard, not a layout change
    resizeRaf = window.requestAnimationFrame(function () {
      resizeRaf = null;
      reserveHeight();
      update();
    });
  }

  function onScroll(evt) {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () { update(evt); });
  }

  // Capture phase catches scroll from ANY scroller (window OR an inner
  // scroll container the frame layout might introduce).
  window.addEventListener('scroll', onScroll, { passive: true, capture: true });
  document.addEventListener('scroll', onScroll, { passive: true, capture: true });
  window.addEventListener('resize', onResize, { passive: true });
  // Re-measure after late layout shifts (web fonts, logo image load) so the
  // reserved height always matches the real tall header.
  window.addEventListener('load', reserveHeight);
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(reserveHeight);
  }
  document.addEventListener('shopify:section:load', reserveHeight);

  reserveHeight();
  update();
})();

  // ---- Predictive search ----
  (function () {
          var panel = root.querySelector('[data-search]');
    var toggle = root.querySelector('.art-header__search-toggle');
    var toggles = document.querySelectorAll('.art-header__search-toggle');
    var input = root.querySelector('[data-search-input]');
    var closeBtn = root.querySelector('[data-search-close]');
    var results = root.querySelector('[data-search-results]');
    if (!panel || !toggle || !input) return;

    var suggestUrl = root.getAttribute('data-suggest-url');
    var searchUrl = root.getAttribute('data-search-url');
    var labels = { products: root.getAttribute('data-t-products'), collections: root.getAttribute('data-t-collections'), posts: root.getAttribute('data-t-posts') || 'Blog & events', pages: root.getAttribute('data-t-pages') || 'Pages', all: root.getAttribute('data-t-all'), services: root.getAttribute('data-t-services') || 'Services', empty: root.getAttribute('data-t-empty') || 'No matches for “%s”. Press Enter to search everything.' };
    // Service cards (metaobjects) are not in Shopify's predictive index: match
    // them here — any query word of 2+ chars against title, short text and the
    // handle's English words; ranked by how many words matched (same rule as
    // the search page).
    var services = [];
    try { var blob = root.querySelector('[data-search-services]'); services = blob ? JSON.parse(blob.textContent) : []; } catch (e) { services = []; }
    services.forEach(function (s) { s.hay = ((s.t || '') + ' ' + (s.s || '') + ' ' + (s.k || '')).toLowerCase(); });
    function matchServices(term) {
      var words = term.toLowerCase().replace(/[&,.!?"']+/g, ' ').split(/\s+/).filter(function (w) { return w.length >= 2; });
      if (!words.length) return [];
      return services.map(function (s) {
        var n = 0;
        words.forEach(function (w) { if (s.hay.indexOf(w) !== -1) n++; });
        return { s: s, n: n };
      }).filter(function (m) { return m.n > 0; })
        .sort(function (a, b) { return b.n - a.n; })
        .slice(0, 4)
        .map(function (m) { return m.s; });
    }
    var debounce;
    var pending = (window.__ahPending = window.__ahPending || new Set());
    var currentFetch;

    function openSearch() {
      root.classList.add('art-header--searching');
      toggles.forEach(function (t) { t.setAttribute('aria-expanded', 'true'); });
      // Phones: the search bar sits at the top of the page (its fixed position is
      // relative to the frame, not the viewport) → glide up to it every time.
      // The input is focused right away, inside the tap, so iOS opens the
      // keyboard (a delayed focus wouldn't); any typed text is pre-selected.
      if (window.matchMedia && window.matchMedia('(max-width: 990px)').matches) {
        try { window.scrollTo({ top: 0, left: 0, behavior: 'smooth' }); } catch (e) { window.scrollTo(0, 0); }
      }
      try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); }
      input.select();
    }
    function closeSearch() {
      root.classList.remove('art-header--searching');
      toggles.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
      input.blur();
      results.hidden = true;
      results.innerHTML = '';
    }

    toggles.forEach(function (t) {
      t.addEventListener('click', function () {
        root.classList.contains('art-header--searching') ? closeSearch() : openSearch();
      });
    });
    if (closeBtn) closeBtn.addEventListener('click', closeSearch);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('art-header--searching')) closeSearch();
    });
    document.addEventListener('click', function (e) {
      if (!root.classList.contains('art-header--searching')) return;
      if (panel.contains(e.target)) return;
      for (var i = 0; i < toggles.length; i++) {
        if (toggles[i].contains(e.target)) return;
      }
      closeSearch();
    });

    function esc(str) {
      return String(str == null ? '' : str).replace(/[&<>"]/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
      });
    }

    function render(data, term) {
      var r = (data.resources && data.resources.results) || {};
      var products = r.products || [];
      var collections = r.collections || [];
      var articles = r.articles || [];
      var pages = r.pages || [];
      var hits = matchServices(term);
      var html = '';

      if (hits.length) {
        html += '<div class="ahs__group"><span class="ahs__group-label">' + esc(labels.services) + '</span><ul class="ahs__list">';
        hits.forEach(function (s) {
          var img = s.i ? '<img src="' + esc(s.i) + '" alt="" loading="lazy" decoding="async">' : '<span class="ahs__noimg"></span>';
          html += '<li><a class="ahs__item" href="' + esc(s.u) + '">' + img +
                  '<span class="ahs__meta"><span class="ahs__title">' + esc(s.t) + '</span>' + (s.s ? '<span class="ahs__price">' + esc(s.s) + '</span>' : '') + '</span></a></li>';
        });
        html += '</ul></div>';
      }

      if (products.length) {
        html += '<div class="ahs__group"><span class="ahs__group-label">' + esc(labels.products) + '</span><ul class="ahs__list">';
        products.forEach(function (p) {
          var img = p.image ? '<img src="' + p.image + '" alt="" loading="lazy" decoding="async">' : '<span class="ahs__noimg"></span>';
          html += '<li><a class="ahs__item" href="' + p.url + '">' + img +
                  '<span class="ahs__meta"><span class="ahs__title">' + esc(p.title) + '</span></span></a></li>';
        });
        html += '</ul></div>';
      }

      if (collections.length) {
        html += '<div class="ahs__group"><span class="ahs__group-label">' + esc(labels.collections) + '</span><ul class="ahs__list ahs__list--plain">';
        collections.forEach(function (c) {
          html += '<li><a class="ahs__item ahs__item--text" href="' + c.url + '">' + esc(c.title) + '</a></li>';
        });
        html += '</ul></div>';
      }

      // Blog and event posts, with their picture; then plain pages.
      if (articles.length) {
        html += '<div class="ahs__group"><span class="ahs__group-label">' + esc(labels.posts) + '</span><ul class="ahs__list">';
        articles.forEach(function (a) {
          var img = a.image ? '<img src="' + esc(a.image) + '" alt="" loading="lazy" decoding="async">' : '<span class="ahs__noimg"></span>';
          html += '<li><a class="ahs__item" href="' + esc(a.url) + '">' + img +
                  '<span class="ahs__meta"><span class="ahs__title">' + esc(a.title) + '</span></span></a></li>';
        });
        html += '</ul></div>';
      }

      if (pages.length) {
        html += '<div class="ahs__group"><span class="ahs__group-label">' + esc(labels.pages) + '</span><ul class="ahs__list ahs__list--plain">';
        pages.forEach(function (pg) {
          html += '<li><a class="ahs__item ahs__item--text" href="' + esc(pg.url) + '">' + esc(pg.title) + '</a></li>';
        });
        html += '</ul></div>';
      }

      if (!products.length && !collections.length && !articles.length && !pages.length && !hits.length) {
        html = '<div class="ahs__empty">' + esc(labels.empty).replace('%s', esc(term)) + '</div>';
      } else {
        html += '<a class="ahs__all" href="' + searchUrl + '?q=' + encodeURIComponent(term) + '">' + esc(labels.all) + ' ' + esc(term) + ' →</a>';
      }

      results.innerHTML = html;
      results.hidden = false;
    }

    input.addEventListener('input', function () {
      var term = input.value.trim();
      clearTimeout(debounce);
      if (currentFetch) { try { currentFetch.abort(); } catch (e) {} pending.delete(currentFetch); }
      if (term.length < 2) { results.hidden = true; results.innerHTML = ''; return; }
      debounce = setTimeout(function () {
        render({}, term); // local service matches right away; products/collections follow
        var url = suggestUrl + '.json?q=' + encodeURIComponent(term) +
                  '&resources[type]=product,collection,article,page&resources[limit]=6&resources[options][unavailable_products]=last';
        var ac = new AbortController();
        currentFetch = ac;
        pending.add(ac);
        fetch(url, { signal: ac.signal })
          .then(function (res) { return res.json(); })
          .then(function (data) { render(data, term); })
          .catch(function () { if (!ac.signal.aborted) results.hidden = true; })
          .then(function () { pending.delete(ac); if (currentFetch === ac) currentFetch = null; });
      }, 200);
    });
  })();

});
